module.exports = __webpack_public_path__ + "static/media/LoginLogo.6d701c92.svg";